import { render } from "./PointCloudProjects.vue?vue&type=template&id=32b9eb1b"
import script from "./PointCloudProjects.vue?vue&type=script&lang=js"
export * from "./PointCloudProjects.vue?vue&type=script&lang=js"

import "./PointCloudProjects.vue?vue&type=style&index=0&id=32b9eb1b&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__